module.exports = __webpack_public_path__ + "static/media/login-app-teaser-mini-v2.88a90e48.jpg";